// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-section {
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    background-color: white;
}
.navbar-title a {
    color: #2e5288;
    letter-spacing: .6px;
    text-decoration: none;
}
.navbar-title {
    font-family: 'Poppins', sans-serif;
}

.navbar-title img{
    position: absolute;
    top: 17px;
    left: 25px;
    width: 290px;
    height: 60px;
    border-radius: 0px;
}

.navbar-items {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 32px;
    font-family: 'Inter', sans-serif;
    font-weight: 400, bold;
    font-size: 20px;
    opacity: 1;
    position: relative;
}

.navbar-items > li {
    list-style-type: none;

}


.navbar-links {
    text-decoration: none;
    color: black;
    font-size: 18px;
    letter-spacing: .8px;
}


#mainNav li a,
#mainNav li a:after,
#mainNav li a:before {
    transition: all .5s;
}
#mainNav li a:hover {
    color:#2e5288;
}

/* stroke */
#mainNav.navbar-items li a
{
    position: relative;
}
#mainNav.navbar-items li a:after,
#mainNav li a:after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 0%;
    content: '.';
    color: transparent;
    background: #2e5288;
    height: 1px;
}
#mainNav.navbar-items li a:hover:after {
    width: 100%;
}

#mainNav li a {
    transition: all 1s;
}

#mainNav li a:after {
    text-align: left;
    content: '.';
    margin: 0;
    opacity: 0;
}
#mainNav li a:hover {
    color: #2e5288;
    z-index: 1;
}
#mainNav li a:hover:after {
    z-index: -10;
    animation: fill 1s forwards;
    opacity: 1;
}


.language-dropdown {
    position: relative;
    background-color: #2e5288;
    border-radius: 4px;
    color: white;
    border: 20px;
}

.language-dropdown select {
    font: 1rem normal Inter, sans-serif;
    max-width: 100%;
    padding: 8px 24px 8px 10px;
    border: none;
    background-color: transparent;
    appearance: none;
    color: white;
}

.language-dropdown select:active,
.language-dropdown select:focus {
    outline: none;
    box-shadow: none;
}

.language-dropdown select::-ms-expand {
    color: white;
}

.language-dropdown select option {
    color: black;
}

.language-dropdown:after {
    content: "";
    position: absolute;
    top: 50%;
    right: 8px;
    width: 0;
    height: 0;
    margin-top: -2px;
    border-top: 5px solid;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
}




/* Hamburger Icon */
.mobile-nav {
    display: none;
}
.hamb-icon {
    width: 26px;
    height: 26px;
    cursor: pointer;
}


.hamb-icon:hover {
    color: #2e5288;
}
/* Mobile Navbar */
.mobile-navbar {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: -100%;
    background-color: white;
    z-index: 20;
    justify-content: center;
    align-items: center;
    transition: left .5s ease-in-out;
}

.mobile-navbar-close {
    position: absolute;
    top: 28px;
    right: 28px;
}
.mobile-navbar-close .hamb-icon:hover {
    color: rgb(255, 22, 22);
}
.open-nav {
    left: 0;
}
.mobile-navbar-links {
    list-style-type: none;
    display: flex;
    flex-direction: column;
    font-size: 24px;
    gap: 24px;
    text-align: center;
}
.mobile-navbar-links li a {
    text-decoration: none;
    color: black;
    font-family: 'Inter', sans-serif;
    font-weight: bold;
    letter-spacing: .8px;
    transition: color .3s ease-in-out;
}

#mainNav_mobile li a:after,
#mainNav_mobile li a:before {
    transition: all .5s;
}
#mainNav_mobile li a:hover {
    color:#2e5288;
}

/* stroke */
#mainNav_mobile.mobile-navbar-links li a
{
    position: relative;
}
#mainNav_mobile.mobile-navbar-links li a:after,
#mainNav_mobile li a:after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 0%;
    content: '.';
    color: transparent;
    background: #2e5288;
    height: 1px;
}
#mainNav_mobile.mobile-navbar-links li a:hover:after {
    width: 100%;
}

#mainNav_mobile li a {
    transition: all 1s;
}

#mainNav_mobile li a:after {
    text-align: left;
    content: '.';
    margin: 0;
    opacity: 0;
}
#mainNav_mobile li a:hover {
    color: #2e5288;
    z-index: 1;
}
#mainNav_mobile li a:hover:after {
    z-index: -10;
    animation: fill 1s forwards;
    opacity: 1;
}

/* Responsive */
@media screen and (max-width: 1435px) {
    .main-container,.select-container, .navbar-items {
        display: none;
    }
    .mobile-nav {
        display: block;
    }



}
`, "",{"version":3,"sources":["webpack://./src/Styles/Navbar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gCAAgC;IAChC,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;;AAEzB;;;AAGA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;;AAGA;;;IAGI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;;AAEA,WAAW;AACX;;IAEI,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,UAAU;AACd;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,YAAY;IACZ,2BAA2B;IAC3B,UAAU;AACd;;;AAGA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,0BAA0B;IAC1B,YAAY;IACZ,6BAA6B;IAG7B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,mCAAmC;IACnC,kCAAkC;AACtC;;;;;AAKA,mBAAmB;AACnB;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;;AAGA;IACI,cAAc;AAClB;AACA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,eAAe;IACf,MAAM;IACN,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,OAAO;AACX;AACA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,gCAAgC;IAChC,iBAAiB;IACjB,oBAAoB;IACpB,iCAAiC;AACrC;;AAEA;;IAEI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;;AAEA,WAAW;AACX;;IAEI,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,UAAU;AACd;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,YAAY;IACZ,2BAA2B;IAC3B,UAAU;AACd;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;;;;AAIJ","sourcesContent":[".navbar-section {\n    padding: 0 32px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 80px;\n    background-color: white;\n}\n.navbar-title a {\n    color: #2e5288;\n    letter-spacing: .6px;\n    text-decoration: none;\n}\n.navbar-title {\n    font-family: 'Poppins', sans-serif;\n}\n\n.navbar-title img{\n    position: absolute;\n    top: 17px;\n    left: 25px;\n    width: 290px;\n    height: 60px;\n    border-radius: 0px;\n}\n\n.navbar-items {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 32px;\n    font-family: 'Inter', sans-serif;\n    font-weight: 400, bold;\n    font-size: 20px;\n    opacity: 1;\n    position: relative;\n}\n\n.navbar-items > li {\n    list-style-type: none;\n\n}\n\n\n.navbar-links {\n    text-decoration: none;\n    color: black;\n    font-size: 18px;\n    letter-spacing: .8px;\n}\n\n\n#mainNav li a,\n#mainNav li a:after,\n#mainNav li a:before {\n    transition: all .5s;\n}\n#mainNav li a:hover {\n    color:#2e5288;\n}\n\n/* stroke */\n#mainNav.navbar-items li a\n{\n    position: relative;\n}\n#mainNav.navbar-items li a:after,\n#mainNav li a:after {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 0%;\n    content: '.';\n    color: transparent;\n    background: #2e5288;\n    height: 1px;\n}\n#mainNav.navbar-items li a:hover:after {\n    width: 100%;\n}\n\n#mainNav li a {\n    transition: all 1s;\n}\n\n#mainNav li a:after {\n    text-align: left;\n    content: '.';\n    margin: 0;\n    opacity: 0;\n}\n#mainNav li a:hover {\n    color: #2e5288;\n    z-index: 1;\n}\n#mainNav li a:hover:after {\n    z-index: -10;\n    animation: fill 1s forwards;\n    opacity: 1;\n}\n\n\n.language-dropdown {\n    position: relative;\n    background-color: #2e5288;\n    border-radius: 4px;\n    color: white;\n    border: 20px;\n}\n\n.language-dropdown select {\n    font: 1rem normal Inter, sans-serif;\n    max-width: 100%;\n    padding: 8px 24px 8px 10px;\n    border: none;\n    background-color: transparent;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    color: white;\n}\n\n.language-dropdown select:active,\n.language-dropdown select:focus {\n    outline: none;\n    box-shadow: none;\n}\n\n.language-dropdown select::-ms-expand {\n    color: white;\n}\n\n.language-dropdown select option {\n    color: black;\n}\n\n.language-dropdown:after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    width: 0;\n    height: 0;\n    margin-top: -2px;\n    border-top: 5px solid;\n    border-right: 5px solid transparent;\n    border-left: 5px solid transparent;\n}\n\n\n\n\n/* Hamburger Icon */\n.mobile-nav {\n    display: none;\n}\n.hamb-icon {\n    width: 26px;\n    height: 26px;\n    cursor: pointer;\n}\n\n\n.hamb-icon:hover {\n    color: #2e5288;\n}\n/* Mobile Navbar */\n.mobile-navbar {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    left: -100%;\n    background-color: white;\n    z-index: 20;\n    justify-content: center;\n    align-items: center;\n    transition: left .5s ease-in-out;\n}\n\n.mobile-navbar-close {\n    position: absolute;\n    top: 28px;\n    right: 28px;\n}\n.mobile-navbar-close .hamb-icon:hover {\n    color: rgb(255, 22, 22);\n}\n.open-nav {\n    left: 0;\n}\n.mobile-navbar-links {\n    list-style-type: none;\n    display: flex;\n    flex-direction: column;\n    font-size: 24px;\n    gap: 24px;\n    text-align: center;\n}\n.mobile-navbar-links li a {\n    text-decoration: none;\n    color: black;\n    font-family: 'Inter', sans-serif;\n    font-weight: bold;\n    letter-spacing: .8px;\n    transition: color .3s ease-in-out;\n}\n\n#mainNav_mobile li a:after,\n#mainNav_mobile li a:before {\n    transition: all .5s;\n}\n#mainNav_mobile li a:hover {\n    color:#2e5288;\n}\n\n/* stroke */\n#mainNav_mobile.mobile-navbar-links li a\n{\n    position: relative;\n}\n#mainNav_mobile.mobile-navbar-links li a:after,\n#mainNav_mobile li a:after {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 0%;\n    content: '.';\n    color: transparent;\n    background: #2e5288;\n    height: 1px;\n}\n#mainNav_mobile.mobile-navbar-links li a:hover:after {\n    width: 100%;\n}\n\n#mainNav_mobile li a {\n    transition: all 1s;\n}\n\n#mainNav_mobile li a:after {\n    text-align: left;\n    content: '.';\n    margin: 0;\n    opacity: 0;\n}\n#mainNav_mobile li a:hover {\n    color: #2e5288;\n    z-index: 1;\n}\n#mainNav_mobile li a:hover:after {\n    z-index: -10;\n    animation: fill 1s forwards;\n    opacity: 1;\n}\n\n/* Responsive */\n@media screen and (max-width: 1435px) {\n    .main-container,.select-container, .navbar-items {\n        display: none;\n    }\n    .mobile-nav {\n        display: block;\n    }\n\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
